<template>
  <div class="v3kiosk-view">
    <div class="d-flex justify-content-end p-3">
      <KioskLocaleSelector />
    </div>
    <KioskLoginForm />
  </div>
</template>
<script>
import KioskLoginForm from "@/v3components/Forms/KioskForms/KioskLoginForm.vue"
import KioskLocaleSelector from "@/v3components/Forms/KioskLocaleSelector.vue"

export default {
  name: "KioskLogin",
  components: {
    KioskLoginForm,
    KioskLocaleSelector
  }
}
</script>
